"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../../core/conversions/DataObjectConverter");
/**
 * AgencyQualityEvaluationDTOConverter
 *
 * @author VBr
 */


var AgencyQualityEvaluationDTOConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(AgencyQualityEvaluationDTOConverter, _DataObjectConverter_);

  function AgencyQualityEvaluationDTOConverter() {
    _classCallCheck(this, AgencyQualityEvaluationDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(AgencyQualityEvaluationDTOConverter).apply(this, arguments));
  }

  return AgencyQualityEvaluationDTOConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.AgencyQualityEvaluationDTOConverter = AgencyQualityEvaluationDTOConverter;